import React, { useState } from 'react';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
  TextField,
  MenuItem,
} from '@material-ui/core';

import { PosPlugin } from 'plugins/plugin';
import { getPluginConfiguration } from 'reducers/Plugins';
import { addError, addSuccess } from 'actions/Error';
import { getManualPromotions } from 'reducers/CampaignsDB';

import { pluginID } from './constants';

export interface Config {
  isProduction: boolean;
  seniorPromotionID: number;
}

export const getConfiguration = getPluginConfiguration<Config>(pluginID);

export const Configuration: Required<
  PosPlugin<Config>
>['ComponentConfigurationByLevel']['Company'] = ({ save, current }) => {
  const dispatch = useDispatch();

  const promotions = useSelector(getManualPromotions);

  const [value, setValue] = useState(current);

  const onChange = key =>
    R.pipe(
      R.ifElse(
        R.propEq('type', 'checkbox'),
        R.path(['target', 'checked']),
        R.path(['target', 'value']),
      ),
      R.assoc(key),
      setValue,
    );

  const saveConfig = () => {
    if (!value || !Object.keys(value).length) {
      dispatch(addError('Configuration is empty'));
      return;
    }
    save(value);
    dispatch(addSuccess('Configuration saved'));
  };

  return (
    <>
      <Box marginTop="15px">
        <Typography variant="h6">Customer card number</Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={value?.isProduction ?? false}
              onChange={onChange('isProduction')}
            />
          }
          label="Use production environment for card number generation/registration service"
        />
      </Box>
      <Box marginY="15px">
        <Typography variant="h6">Customer senior status</Typography>
        <TextField
          select
          fullWidth
          margin="normal"
          variant="outlined"
          label="Senior promotion"
          value={value?.seniorPromotionID ?? 0}
          onChange={onChange('seniorPromotionID')}
        >
          <MenuItem value={0}>Select option</MenuItem>
          {promotions.map(({ campaignID, name }) => (
            <MenuItem value={campaignID}>{name}</MenuItem>
          ))}
        </TextField>
      </Box>

      <Button variant="contained" color="primary" onClick={saveConfig}>
        Save
      </Button>
    </>
  );
};
